// extracted by mini-css-extract-plugin
module.exports = {"label":"Login_label__1vqrb","input":"Login_input__1OQXX","button":"Login_button__3QzWC"};